<template>
  <div id="cancel-services" class="container">
    <div class="columns">
      <div class="column is-6"><LsSupportHeader :label="t('standaloneCancellation.title')" /></div>
    </div>
    <BLoading :active.sync="properties.loadingStatus.isLoading" />
    <div v-if="!properties.loadingStatus.isLoading" class="columns">
      <div class="column is-4"><LsNavItems :items="items" test-id="nav_items" /></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { lsModalService } from 'ls-vue-common';
import { CancelSubscriptionModal } from '@/modals';
import { LsSupportHeader, LsNavItems } from '@/views/Authorized/SupportView/components';
import { themedComponentMixin } from '@/mixins';
import { mapActions, mapGetters, mapState } from 'vuex';
import {
  PROPERTIES__CAN_CANCEL_MOWING_SERVICES,
  PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
  SCHEDULES__ACTIVE_SERVICES,
} from '@/store/types';
import { API_SERVICE_TYPES, ROUTE_NAMES } from '@/constants';

export default {
  name: 'SelectCancelServiceView',
  components: { LsSupportHeader, LsNavItems },
  mixins: [themedComponentMixin],
  computed: {
    ...mapState(['schedules', 'properties']),
    ...mapGetters({
      SCHEDULES__ACTIVE_SERVICES,
      PROPERTIES__CAN_CANCEL_MOWING_SERVICES,
    }),
    items() {
      return _.map(this[SCHEDULES__ACTIVE_SERVICES], (service) => ({
        label: service.name,
        type: 'chevron',
        onClick: () => this.cancelSelectedService({ service }),
      }));
    },
  },
  async created() {
    await this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]();
  },
  methods: {
    ...mapActions([PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]),
    async cancelSelectedService({ service }) {
      const isMowing = service.str_id === API_SERVICE_TYPES.MOWING;

      if (!isMowing) {
        return lsModalService.open({
          parent: this,
          component: CancelSubscriptionModal,
          props: {
            isLtrs: service.is_ltrs,
            serviceId: service.service_id,
          },
        });
      }

      if (!this[PROPERTIES__CAN_CANCEL_MOWING_SERVICES]) {
        return this.$router.push({
          name: ROUTE_NAMES.BLOCK_CANCEL_SUBSCRIPTION,
        });
      }

      return this.$router.push({
        name: ROUTE_NAMES.PAUSE_SUBSCRIPTION,
        params: {
          isLtrs: service.is_ltrs,
          serviceId: service.service_id,
        },
      });
    },
  },
};
</script>
<style lang="scss">
#cancel-services {
  .ls-nav-items--link {
    font-size: 18px;
    font-weight: 600;
    color: $theme-color-primary;
    &:hover {
      color: $theme-color-primary-hover;
    }
    margin: 12px 0 12px 0;
  }
  .top-border {
    border-top: 1px solid $theme-color-gray;
  }
}
</style>
